import { initializeSentry } from '../../../packages/components/src/utilities/sentry';

initializeSentry();
